import Vue from 'vue';

// State definition
const state = () => ({
    timersStates: [] // Array to hold timer states
});

// Mutations to update the state
const mutations = { 
    setTimersStates(state, timersStates) {
        state.timersStates = timersStates; // Set the entire timersStates array
    },
    setTimerState(state, timerState) {
        state.timersStates.push(timerState); // Add a new timer state to the array
    },
    updateTimerState(state, { index, timerState }) {
        Vue.set(state.timersStates, index, timerState); // Update a specific timer state at the given index
    },
    updateTimerDisabledSend(state, { index, disabledSend }) {
        Vue.set(state.timersStates[index], 'disabledSend', disabledSend); // Update the disabledSend property of a specific timer state
    },
    updateTimerTimeDisabled(state, { index, timeDisabled }) {
        Vue.set(state.timersStates[index], 'timeDisabled', timeDisabled); // Update the timeDisabled property of a specific timer state
    }
}

// Getters to access the state
const getters = {
    getTimerStates: state => state.timersStates // Get the array of timer states
}

// Actions to perform asynchronous operations and commit mutations
const actions = {
    startTimerDisabledAction({ commit, getters }, timerState) {
        const { waiverId, userId, componentName } = timerState;
        let timerStates = getters.getTimerStates;
        // Find the index of the timer state that matches the given criteria
        let index = timerStates.findIndex(el => el.componentName === componentName && el.waiverId == waiverId && el.userId == userId);
    
        if (index !== -1) {
           let find = timerStates[index];
           find.disabledSend = true;
           find.timeDisabled = 15;
           // Commit mutation to update the entire timer state
           commit('updateTimerState', { index, timerState: find });
           
           // Start an interval to decrease timeDisabled every second
           let idInterval = setInterval(() => {
                find.timeDisabled -= 1;
                // Commit mutation to update the timeDisabled property
                commit('updateTimerTimeDisabled', { index, timeDisabled: find.timeDisabled });
                if (find.timeDisabled <= 0) {
                    clearInterval(idInterval); // Clear the interval when timeDisabled reaches 0
                }
            }, 1000);

            // Set a timeout to reset disabledSend after 15 seconds
            setTimeout(() => {
                find.disabledSend = false;
                // Commit mutation to update the disabledSend property
                commit('updateTimerDisabledSend', { index, disabledSend: find.disabledSend });
            }, 15000);
        }
    },
    settingTimer({ commit, getters }, waiverData) {
        const { waiverId, userId, componentName } = waiverData;
        let timerStates = getters.getTimerStates;
        // Check if a timer state already exists for the given waiverId and userId
        if (!timerStates.find(el => el.waiverId == waiverId && el.userId == userId)) {
            // Commit mutation to add a new timer state
            commit('setTimerState', {
                waiverId,
                userId,
                disabledSend: false,
                timeDisabled: 0,
                componentName
            });
        }
    }
}

export default {
    state, mutations, actions, getters
}
